module.exports = __webpack_public_path__ + "static/img/YellowBubble@3x.faafda0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/YellowBubble@3x.png
// module id = G+85
// module chunks = 0